import React, { FC } from 'react';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import Team from './Team';

const WhoWeAre: FC = () => {
  return (
    <Grid pt={24}>
      <Box sx={{ background: 'linear-gradient(to left, #15183A, #638DB8)', mb: { xs: 4, sm: 8 } }}>
        <Typography
          fontFamily="Roboto"
          fontSize="22px"
          lineHeight="25px"
          fontWeight="500"
          textAlign="center"
          color="white"
          p={{ xs: 2, sm: 4 }}
        >
          Estamos construyendo el futuro, súmate!
        </Typography>
      </Box>

      <Team />
    </Grid>
  );
};

export default WhoWeAre;
